export default "__VITE_ASSET__Ai9d8QWp__"